import { memo, useEffect, useState } from 'react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Link,
} from '@material-ui/core';

const DESCRIPTION =
  'Inform application clients about potential disruptions during KaaP upgrades 5 days ahead.';

type CabInformSectionProps = {
  value?: boolean;
  tier?: string;
  onChange: (value: boolean) => void;
};

export const CabInformSection = memo(
  ({ value, tier, onChange }: CabInformSectionProps) => {
    const hasValue = typeof value === 'boolean';
    const [wasChangedByUser, setWasChangedByUser] = useState(hasValue);

    useEffect(() => {
      if (wasChangedByUser) {
        return;
      }

      if (tier !== 'external') {
        onChange(false);
        return;
      }

      onChange(tier === 'external');
    }, [tier, onChange, wasChangedByUser]);

    const currentValue = hasValue ? value : tier === 'external';

    if (tier !== 'external' || !tier) {
      return null;
    }

    return (
      <FormControl>
        <FormControlLabel
          control={
            <Checkbox
              id="cab-inform"
              checked={Boolean(currentValue)}
              onChange={event => {
                setWasChangedByUser(true);
                onChange(event.target.checked);
              }}
            />
          }
          label="CAB: Inform clients"
        />
        <FormHelperText>
          <span>
            {DESCRIPTION}{' '}
            <Link
              target="_blank"
              href="https://frontstage.tomtomgroup.com/docs/default/component/kaap-documentation/guardrails#cab-inform-clients"
            >
              More details.
            </Link>
          </span>
        </FormHelperText>
      </FormControl>
    );
  },
);
